

















import {Component,Prop, Vue} from 'vue-property-decorator';

@Component({
    components: {},
    name: "ConfirmModal"
})
export default class ConfirmModal extends Vue {
    @Prop(Boolean) private readonly value!:boolean;

    get show(){
        return this.value
    }

    set show(val:boolean){
        this.$emit('input',val)
    }

}

